const addUser = (payload) => {
    return {
        type: 'ADD_USER',
        payload,
    };
};
const addConfig = (payload) => {
    return {
        type: 'ADD_CONFIG',
        payload,
    };
};
const removeUser = () => {
    return {
        type: 'REMOVE_USER',
        payload: null,
    };
};
const sharedStateReducer = (state, action) => {
    switch (action.type) {
        case 'ADD_CONFIG': {
            return {
                ...state,
                config: {
                    ...state.config,
                    ...action.payload,
                },
            };
        }
        case 'ADD_USER': {
            return {
                ...state,
                user: action.payload,
            };
        }
        case 'REMOVE_USER': {
            return {
                ...state,
                user: null,
            };
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
};
export default sharedStateReducer;
export { addUser, removeUser, addConfig };
